
<val-boite-dialogue-generique #boiteDialogueLog
                              class="val-boite-dialogue-log"
                              [titre]="titre"
                              annulerVisible="false"
                              [validerDesactive]="validerDesactiver"
                              (validerClick)="Fermer()">
  <div bandeau
       class="val-boite-dialogue-log-bandeau">
    <val-simple-libelle [libelle]="bandeau">
    </val-simple-libelle>
  </div>
  <div contenu
       class="val-boite-dialogue-log-contenu">
    <val-simple-tree-view [items]="items"
                          [itemsOuverts]="itemsOuverts"
    ></val-simple-tree-view>
  </div>
  <div bandeau-bas
       [ngClass]="{'val-invisible': etendu < 1}"
       class="val-boite-dialogue-log-bandeau-bas">
    <val-barre-progression [etendu]="etendu"
                           [position]="position">
    </val-barre-progression>
  </div>
  <div piedPage
       class="val-boite-dialogue-log-pied-page val-flex-conteneur">
    <val-simple-image class="val-boite-dialogue-log-pied-page-erreur-icone"
                      [width]="16"
                      [height]="16"
                      src="assets/iconeRg0.png">
    </val-simple-image>
    <val-simple-libelle class="val-boite-dialogue-log-pied-page-erreur-libelle"
                        libelle="Erreurs : ">
    </val-simple-libelle>
    <val-simple-libelle class="val-boite-dialogue-log-pied-page-erreur-valeur"
                        [libelle]="nombreErreur.toString()">
    </val-simple-libelle>
    <val-simple-image class="val-boite-dialogue-log-pied-page-avertissement-icone"
                      [width]="16"
                      [height]="16"
                      src="assets/iconeRg5.png">
    </val-simple-image>
    <val-simple-libelle class="val-boite-dialogue-log-pied-page-avertissement-libelle"
                        libelle="Avertissements : ">
    </val-simple-libelle>
    <val-simple-libelle class="val-boite-dialogue-log-pied-page-avertissement-valeur"
                        [libelle]="nombreAvertissement.toString()">
    </val-simple-libelle>
  </div>
</val-boite-dialogue-generique>
<val-boite-dialogue-rg-simple #boiteDialogueRgSimple
                              [titre]="titreDialogueRg"
                              [boutonOkVisible]="boutonOkVisible"
                              [boutonOuiVisible]="boutonOuiVisible"
                              [boutonNonVisible]="boutonNonVisible"
                              [boutonAbandonnerVisible]="boutonAbandonnerVisible"
                              [boutonRecommencerVisible]="boutonRecommencerVisible"
                              [boutonAnnulerVisible]="boutonAnnulerVisible"
                              [boutonIgnorerVisible]="boutonIgnorerVisible"
                              [message]="message"
                              [iconeVisible]="iconeVisible"
                              [icone]="icone">
</val-boite-dialogue-rg-simple>
<val-boite-dialogue-rg-date #boiteDialogueRgDate
                            [titre]="titreDialogueRg"
                            [bandeau]="message"
                            >
</val-boite-dialogue-rg-date>
